export default "__VITE_ASSET__CcHsQO0s__"